import { stringToast, wait } from "../companiens/default/utilities";

export const Error = () => {
    let styles = `
        h1 {
            font-size: 5.9em;
        }
        h3 {
            font-size: 2.7em;
        }
        h3 + p {
            font-size: 1.2em;
        }
        img {
            transform: scale(1.1);
        }
    `
    const handleBack = async () => {
        // stringToast("Please wait a moment.", { type: 'error', autoClose: 2000 });
        window.reloadPage();
    }
    return (
    <section className="error-container p-lg-5 vh-100">
        <style>{styles}</style>
        <div className="p-5 bg-purple-50 d-flex flex-column-reverse flex-lg-row h-100" >
            <div className="d-flex flex-column" style={{gap: '2rem', fontFamily: 'Poppins', fontSize: 'clamp(0.4em, 2.6vw, 1em)'}}>
                <h1>Oops..</h1>
                <h3 className="lh-base text-rose-600">An Unexpected Error has occured.</h3>
                <p>Please try again later.</p>
                <div className="hero-cta btn-group-1 d-flex gap-4 justify-content-center justify-content-lg-start">
                    <button style={{ background: "#c970ff", color: "white" }} onClick={handleBack}>
                        BACK TO HOME
                    </button>
                </div>
                <p className="mt-auto d-flex align-items-center gap-2 text-blue-600" style={{fontSize: '1.6rem'}}><i className='bx bxs-error'></i> Description of actual error.</p>
            </div>
            <div className="">
                <img src="img/error.png" alt="ERROR" className="img-fluid" />
            </div>
        </div>
    </section>
    )
}

export const ListLoader = ({ classes='h-[91px]', count=4, containerClass='gap-3 mb-6' }) => {
  return (
    <div className={`flex flex-column justify-between overflow-hidden ${containerClass}`}>
      {Array.from(Array(count).keys()).map(i => (<div className={`${classes} w-full skeleton-box`} key={i}></div>))}
    </div>
  )
}

export const GridLoader = ({ classes='h-[140px] flex-1', count=6, containerClass='gap-3 mb-6' }) => {
  return (
    <div className={`flex justify-between overflow-hidden ${containerClass}`}>
      {Array.from(Array(count).keys()).map(i => (<div className={`${classes} skeleton-box`} key={i}></div>))}
    </div>
  )
}


  